<template>
  <div
    class="gridItem"
    :class="`
      xs-${xs}
      md-${md}
      lg-${lg}
      xl-${xl}
      ${mobilePaddingNone ? 'mobilePaddingNone' : ''}
     `"
    :style="{padding, marginBottom: mb}"
  >
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'GridItem',
    props: {
      xs: String,
      md: String,
      lg: String,
      xl: String,
      padding: String,
      mb: String,
      mobilePaddingNone: Boolean
    }
  }
</script>

<style scoped lang="scss">
  .gridItem {
    padding: 0 15px;
  }
  @media screen and (min-width: 0px){
    .xs-2 {
      width: 16.66%;
    }
    .xs-2d4 {
      width: 20%;
    }
    .xs-3 {
      width: 25%;
    }
    .xs-4 {
      width: 33.33%;
    }
    .xs-6 {
      width: 50%;
    }
    .xs-7 {
      width: 58.3%;
    }
    .xs-8 {
      width: 66.66%;
    }
    .xs-9 {
      width: 75%;
    }
    .xs-10 {
      width: 83.33%;
    }
    .xs-12 {
      width: 100%;
    }
  }
  @media screen and (min-width: 576px){
    .md-2 {
      width: 16.66%;
    }
    .md-2d4 {
      width: 20%;
    }
    .md-3 {
      width: 25%;
    }
    .md-4 {
      width: 33.33%;
    }
    .md-6 {
      width: 50%;
    }
    .md-8 {
      width: 66.66%;
    }
    .md-9 {
      width: 75%;
    }
    .md-10 {
      width: 83.33%;
    }
    .md-12 {
      width: 83.33%;
    }
  }
  @media screen and (min-width: 900px){
    .lg-2 {
      width: 16.66%;
    }
    .lg-2d4 {
      width: 20%;
    }
    .lg-3 {
      width: 25%;
    }
    .lg-4 {
      width: 33.33%;
    }
    .lg-6 {
      width: 50%;
    }
    .lg-8 {
      width: 66.66%;
    }
    .lg-9 {
      width: 75%;
    }
    .lg-10 {
      width: 83.33%;
    }
    .lg-12 {
      width: 100%;
    }
  }
  @media screen and (min-width: 1170px){
    .xl-2 {
      width: 16.66%;
    }
    .xl-2d4 {
      width: 20%;
    }
    .xl-3 {
      width: 25%;
    }
    .xl-4 {
      width: 33.33%;
    }
    .xl-6 {
      width: 50%;
    }
    .xl-8 {
      width: 66.66%;
    }
    .xl-9 {
      width: 75%;
    }
    .xl-10 {
      width: 83.33%;
    }
    .xl-12 {
      width: 100%;
    }
  }
  @media screen and (max-width: 1170px){
    .gridItem.mobilePaddingNone {
      padding: 0 !important;
    }
  }
</style>
